export default __webpack_public_path__ + "static/media/banner-logo.888dbfa7.png";